// Wrap performance.mark to create extra layer in case of production optimisation
// for example to remove the execution part.
export const mark = (key: string): void => {
  performance.mark(key)
}
